import { type Template as PartnersTemplate } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';
import { type StripsItemTemplate } from 'hb-react/backoffice/types/builder/itemAttributes/stripsItemAttributes';

import { type ItemAttributes } from './itemAttributes';

export enum BUILDER_CONTEXT_ID {
  EMAIL_GROUP = 'email-group',
  EMAIL_NETWORK = 'email-network',
  EMAIL_TEMPLATE_NETWORK = 'email-templates-network',
  PAGE_EVENT = 'page-event',
  PAGE_GROUP = 'page-group',
  PAGE_NETWORK = 'page-network',
  PAGE_TEMPLATE_NETWORK = 'page-templates-network',
}

export enum BUILDER_DOCUMENT_TYPE {
  EMAIL = 'email',
  PAGE = 'page',
}

export enum BUILDER_DOCUMENT_CATEGORIES {
  BLOCK = 'block',
  DYNAMIC = 'dynamic',
  SIMPLE = 'simple',
}

export enum BUILDER_DOCUMENT_GLOBAL_TYPE {
  BODY = 'Body',
  ROOT = 'Root',
}

export enum BUILDER_DOCUMENT_CHILDREN_TYPE {
  BUTTON = 'Button',
  BUTTONS = 'Buttons',
  COLUMN = 'Column',
  DIVIDER = 'Divider',
  DROPPABLE_LAST_BLOCK = 'DroppableLastBlock',
  EMPTY_DOCUMENT_PLACEHOLDER = 'EmptyDocumentPlaceholder',
  HERO = 'Hero',
  HEROSLIDER = 'HeroSlider',
  SECTION = 'Section',
  SLIDE = 'Slide',
  TEXT = 'Text',
  USER_BANNER = 'UserBanner',
}

export enum EMAIL_BUILDER_DOCUMENT_CHILDREN_TYPE {
  EMAIL_ACTIVATION_BUTTON = 'EmailActivationButton',
  EMAIL_FOOTER = 'EmailFooter',
  EMAIL_IMAGE = 'EmailImage',
  EMAIL_LIST = 'EmailList',
  EMAIL_MIRROR_LINK = 'EmailMirrorLink',
}

export enum PAGE_BUILDER_DOCUMENT_CHILDREN_TYPE {
  PAGE_IMAGE = 'PageImage',
}

export interface DocumentItem<T extends ItemAttributes = ItemAttributes> {
  attributes?: T;
  category?: string;
  children?: Array<DocumentItem>;
  content?: string;
  hb_template_name?: string;
  id: string;
  isMobileSettings?: boolean;
  name?: string;
  shouldBeLazyLoaded?: boolean;
  template?: PartnersTemplate | StripsItemTemplate;
  type: string;
}

export enum BUILDER_DEVICE_MODE {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
